class SizeGuideRegionSelect extends HTMLElement {
  constructor() {
    super();
    this.regions = [];
    this.selectedRegion = "all";
    this.areaEl = null;
    this.selectEl = null;
    this.selectLabel = null;
    this.tables = [];
    this.handleRegionChange = this.handleRegionChange.bind(this);
    this.preselectLocation = false | (this.dataset.preselectLocation === "true");
  }

  connectedCallback() {
    this.selectEl = this.querySelector("select");
    this.selectLabel = this.querySelector(".form__label span");
    this.areaEl = document.querySelector("size-guide-drawer") || this.closest(".size-guide-section");
    this.regions = this.getAvailableRegions();

    if (this.regions.length === 0) return;

    this.populateSelectElement();
    this.selectEl.addEventListener("change", this.handleRegionChange);

    this.preselectVisitorLocation();
    this.showRegionSelector();
  }

  disconnectedCallback() {
    this.selectEl.removeEventListener("change", this.handleRegionChange);
  }

  showRegionSelector() {
    this.classList.remove("hidden");
  }

  preselectVisitorLocation() {
    if (this.preselectLocation) {
      window
        .fetchVisitorBrowsingContextSuggestions()
        .then((visitorInfo) => {
          const visitorCountryName = visitorInfo.detected_values.country.name.toLowerCase();

          if (this.regions.includes(visitorCountryName)) {
            this.filterRegions(visitorCountryName);
            this.selectEl.value = visitorCountryName;
          }
        })
        .catch((error) => console.error("Error fetching visitor info:", error));
    }
  }

  populateSelectElement() {
    this.regions.forEach((region, index) => {
      const option = document.createElement("option");
      const country_code = this.getCountryCode(region);

      option.value = region;
      option.textContent = country_code;

      if (index === 0) {
        this.selectEl.value = region;

        this.selectLabel.textContent = this.selectLabel.textContent + " (" + country_code + ")";

        this.filterRegions(region);
      }

      this.selectEl.appendChild(option);
    });
  }

  filterRegions(selectedRegion) {
    const tables = this.areaEl.querySelectorAll(".size-guide-table");

    selectedRegion = selectedRegion || this.selectedRegion;

    tables.forEach((table) => {
      if (!this.tableHasRegion(table, selectedRegion)) return;

      const regionColumns = table.querySelectorAll(".size-guide-table--international");

      this.selectLabel.textContent = this.selectLabel.textContent.replace(/\(.*?\)/g, `(${this.getCountryCode(selectedRegion)})`);

      regionColumns.forEach((regionColumn) => {
        const dataAttrLocation = regionColumn.getAttribute("data-location").toLowerCase();

        regionColumn.style.display = dataAttrLocation === selectedRegion ? "flex" : "none";
      });
    });
  }

  getCountryCode(region) {
    const location = Array.from(this.tables).find((table) => table.dataset.location.toLowerCase() === region);

    return location.dataset.title;
  }

  tableHasRegion(table, region) {
    return table.querySelectorAll(`[data-location="${region}" i]`).length > 0;
  }

  handleRegionChange(event) {
    this.selectedRegion = event.target.value;

    this.filterRegions();
  }

  getAvailableRegions() {
    let regions = [];

    const sizeGuideDrawer = this.areaEl;

    this.tables = sizeGuideDrawer.querySelectorAll(".size-guide-table .size-guide-table--international");

    this.tables.forEach((table) => {
      regions.push(table.getAttribute("data-location").toLocaleLowerCase());
    });

    regions = regions.filter((region, index, self) => self.indexOf(region) === index && region !== "");

    return regions;
  }
}

class SizeGuideMeasurementSelect extends HTMLElement {
  constructor() {
    super();

    this.measurement = this.dataset.activeMeasurement;
    this.selectEl = null;
    this.handleMeasurementChange = this.handleMeasurementChange.bind(this);
  }

  connectedCallback() {
    this.selectEl = this.querySelector("select");
    this.labelEl = this.querySelector(".form__label span");
    this.selectEl.addEventListener("change", this.handleMeasurementChange);
    this.filterMeasurements();
  }

  disconnectedCallback() {
    this.selectEl.removeEventListener("change", this.handleMeasurementChange);
  }

  handleMeasurementChange(event) {
    this.measurement = event.target.value;

    this.filterMeasurements();
  }

  filterMeasurements() {
    const tables = document.querySelectorAll(".size-guide-table");

    tables.forEach((table) => {
      const measurementColumn = table.querySelector(".size-guide-table--measurement");
      const cells = measurementColumn.querySelectorAll('[class^="size-guide-table__value-"]');

      this.labelEl.textContent = this.labelEl.textContent.replace(/\(.*?\)/g, `(${this.measurement})`);

      cells.forEach((cell) => {
        cell.style.display = cell.classList.contains(`size-guide-table__value-${this.measurement}`) ? "block" : "none";
      });
    });
  }
}

class SizeGuideDrawer extends Drawer {
  constructor() {
    super();
  }
}

class SizeGuideDrawerButton extends DrawerButton {
  constructor() {
    super();
  }
}

customElements.define("size-guide-drawer", SizeGuideDrawer);
customElements.define("size-guide-drawer-button", SizeGuideDrawerButton);
customElements.define("size-guide-region-select", SizeGuideRegionSelect);
customElements.define("size-guide-measurement-select", SizeGuideMeasurementSelect);
